import React, { useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import DateSlider from '../DateSlider';
import { DATE_RANGE_ITEM, TIME_RANGE_ITEM } from '../../interfaces/home';
import EmptyPlaceHolder from '../../components/EmptyPlaceHolder';
import { sendReport } from '../../../../utils/reporter';
import 'swiper/swiper.scss'
import './index.scss';


export default function DateTimeSelector(props) {
  const { dates = [], onDateTimeChange = () => {} } = props;
  const [curSelectedDateItem, setCurSelectedDateItem] = useState<null | DATE_RANGE_ITEM>(null);
  const [timeRangeOfDate, setTimeRangeOfDate] = useState<TIME_RANGE_ITEM[]>([]);
  const uniqueOptionKey = useRef('');

  useEffect(() => {
    if (!dates || dates.length === 0) return;
    const checkedItems = dates.filter(dateItem => {
      return !!dateItem.checked
    });
    if (checkedItems.length > 0) {
      setCurSelectedDateItem(checkedItems[0]);
    }
  }, [dates]);

  useEffect(() => {
    if (!curSelectedDateItem) return
    const { ruleItems } = curSelectedDateItem;
    setTimeRangeOfDate(ruleItems);
  }, [curSelectedDateItem]);

  const onDateItemChange = item => {
    const { reserveQuota, date: targetDate } = item;
    const { date: curDate } = curSelectedDateItem || { date: '' };
    // disabled 状态
    if (reserveQuota <= 0 || curDate === targetDate) return;

    setCurSelectedDateItem(item);
    onDateTimeChange({
      dateItem: {
        ...item,
        checked: true
      },
      timeOptionKey: '',
      startTime: '',
    })
    uniqueOptionKey.current = '';
  }

  const onSelectTimeOption = target => {
    console.log('onSelectTimeOption >>> ', target);
    const { date, startTime, canReserveNumber } = target;
    if (!canReserveNumber) return;
    const dhm = `${date}-${startTime}`;
    if (dhm === uniqueOptionKey.current) return;
    uniqueOptionKey.current = dhm;
    onDateTimeChange({
      dateItem: curSelectedDateItem,
      timeOptionKey: dhm,
      startTime,
    })
    sendReport({
      mcode: "更换门店入口点击",
      point: 'P11183`B012',
    })
  };

  return (
    <div className="date-time-container">
      <DateSlider
        dateList={dates}
        onSelectChanged={onDateItemChange}
      />
      {
        dates && dates.length === 0 ? (
          <EmptyPlaceHolder text="暂无可预约时间" />
        ) : (
          <div className="time-select-field">
            <div className="title">选择时间</div>
            <div className="time-options-list">
              {
                timeRangeOfDate.map((tItem, i) => {
                  // day-hour-min
                  const dhm = `${tItem.date}-${tItem.startTime}`;
                  return (
                    <div
                      key={dhm}
                      className={classNames("time-option-item", {
                        selected: !!tItem.checked,
                        disabled: tItem.canReserveNumber === 0,
                      })}
                      onClick={() => onSelectTimeOption(tItem)}
                    >
                      <span>{ tItem.startTime }</span>
                      <i className="selected-icon" />
                    </div>
                  )
                })
              }
            </div>
          </div>
        )
      }
    </div>
  );
}